import React, { useState, useEffect, useRef } from 'react';
import { getAllTestimonials } from './../../../../api'
import {
    Container,
    Box,
    Typography,
} from "@mui/material";
import Media from 'react-media';
import Image from '../../images/hire.png';
import left from '../../images/scroll-left.svg';
import  Hire from './../Hire';
import './styles.css'

const styles = {
    Container2: {
        backgroundImage: `url(${Image})`,
        backgroundBlendMode: 'multipy',
        minHeight: '100vh',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        padding: "0.12rem"
    }
}


const Testimonials = () => {

  const [allTestimonialData, setAllTestimonialData] = useState([])
  const testimonals = useRef(null);

  useEffect(async () => {
    const response = await getAllTestimonials();
    console.log(response.data)
    setAllTestimonialData(response.data.allTestimonials)
  },[])

  const scroll = (action)=>{
    switch (action) {
      case "LEFT":
        testimonals.current.scrollLeft -= 265
        break;
      case "RIGHT":
        testimonals.current.scrollLeft += 265
        break;
      default:

    }
  }

  return (
    <>
      <Container style={styles.Container2} maxWidth="100%" >
        <Hire />
        <h2 className="landing__testimonal__heading">Testimonal</h2>
        <div className="testimonal--container">
          <div onClick={()=>scroll("LEFT")} className="testimonal--container-left"><img src={left} alt=""/></div>
          <div ref={testimonals} className="testimonal--container-testimonal">
            {allTestimonialData.length===0?
              <h4 className="no__show">There is no testimonal to show</h4>
              :allTestimonialData.map((data, index)=>(
              <div className="testimonal__box" key={index}>
                <img className="testimonal__avtar" src={data.avatar} alt=""/>
                <div>
                  <h3 className="testimonal__name">{data.name}</h3>
                  <h4  className="testimonal__location">{data.location}</h4>
                  <p className="testimonal__description">{data.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div onClick={()=>scroll("RIGHT")} className="testimonal--container-right"><img src={left} alt=""/></div>
        </div>
      </Container>
    </>
  );
}

export default Testimonials
